module.exports = __webpack_public_path__ + "img/me.cac1df24.png";